export default "__VITE_ASSET__9ab99298__"